import React from 'react'

const Header = (props) => {

    return (
        <nav className={`navbar navbar-expand-lg ${props.mode === 'sun' ? 'bg-body-tertiary' : 'navbar-dark bg-black'} `}>
            <div className="container-fluid">
                <div className="image-button img_hover">
                    <img src={require('./download.png')} onClick={() => { props.handleClick() }} alt="Button Icon" />
                </div>
                <a className="navbar-brand" href="#">NewsSite</a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className="nav-link active" aria-current="page" onClick={() => { props.handleClick() }} href="#">Home</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link active" aria-current="page" href="#">About</a>
                        </li>
                    </ul>
                    <div className="image-button img_hover">
                        <img src={require(`./${props.mode}.png`)} onClick={() => { props.handleMode() }} alt="Button Icon" />
                    </div>
                    <form className="d-flex" role="search">
                        <input className="form-control me-2" type="search" placeholder="Search News" aria-label="Search" />
                        <button className={`btn btn-outline-${props.mode === 'sun' ? 'success' : 'danger'}`} type="submit">Search</button>
                    </form>
                </div>
            </div>
        </nav>
    )
}

export default Header
